import axios from 'axios';
import md5 from "md5";

const viewerAccessKey = sessionStorage.getItem('viewerAccessKey') + "=";
axios.interceptors.request.use((config) => {
    if (viewerAccessKey)
    config.headers.Authorization = `Basic ${viewerAccessKey}`;
  return config;
}, (error) => {
  return Promise.reject(error);
});

export class ServiceApi {

    // Adicionando um interceptor de const api = axios.create();
    static _getUrl() {
        return axios.get('config.json')
            .then(res => res.data.servico)
            .then(url => {
                if (url[url.length - 1] === "/")
                    return url;
                return url + "/";
            });
    }

    static _getCnpj() {
        return axios.get('config.json')
            .then(res => {
                return res.data.cnpjCliente
            });
    }

    static post(address, body) {
        return this._getUrl()
            .then(root => axios.post(`${root}${address}`, body, this._getHeaders()))
            .then(res => res.data);
    }

    static postBlob(address, body) {
        return this._getUrl().then(root => {
            const headers = this._getHeaders();

            const config = {
                ...headers,
                responseType: 'blob'
            };

            return axios.post(`${root}${address}`, body, config); // N�O .data
        });
    }

    static get(url) {
        return axios.get(url, this._getHeaders())
            .then(function (response) {
                return response.data;
            });
    }


    static getImages(url) {
        return axios.get(url, this._getHeaders())
            .then(function (response) {
                return response.data;
                //console.log(response.data); // ex.: { user: 'Your User'}
                //console.log(response.status); // ex.: 200
            });
    }

    static _getHeaders() {
        const auth = JSON.parse(`${sessionStorage.getItem("auth")}`);
        if (auth) {
            if (auth.IdMedico != 0) {
                return {
                    headers: {
                        user: auth.Login,
                        Cnonce: auth.Cnonce,
                        Token: md5(auth.Login + auth.Cnonce + auth.Token),
                        TokenPortal: "",
                        isPacientePortal: "false",
                        isConvenioPortal: "false",
                    },
                };
            }
            else if (auth.IdConvenio != 0) {
                return {
                    headers: {
                        user: auth.Login,
                        Cnonce: auth.Cnonce === null ? "" : auth.Cnonce,
                        Token: auth.Md5 === null ? "" : auth.Md5,
                        TokenPortal: "",
                        isPacientePortal: "false",
                        isConvenioPortal: "true",
                    },
                };
            }
            else {
                if (auth.Irrestrito) {
                    return {
                        headers: {
                            user: auth.Login,
                            Cnonce: auth.Cnonce,
                            Token: md5(auth.Login + auth.Cnonce + auth.Token),
                            TokenPortal: "",
                            isPacientePortal: "false",
                            isConvenioPortal: "false",
                        },
                    };
                } else {
                    return {
                        headers: {
                            user: auth.Id,
                            Cnonce: auth.Cnonce === null ? "" : auth.Cnonce,
                            Token: auth.Md5 === null ? "" : auth.Md5,
                            TokenPortal: auth.TokenPortal == null ? "" : auth.TokenPortal,
                            isPacientePortal: "true",
                            isConvenioPortal: "false",
                        },
                    };
                }
            }
        } else return undefined;
    }
}